/**
 * Icones decorativos.
 *
 * Todos sao `aria-hidden`: o significado vem do texto ao lado, sempre vindo do
 * catalogo. Icone com nome acessivel proprio duplicaria o anuncio do leitor de
 * tela sem acrescentar informacao.
 */

interface IconProps {
  readonly className?: string | undefined;
}

export function ErrorIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M10 1.5 19 18H1L10 1.5Zm0 5.5a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Zm0 8.25a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3Z" />
    </svg>
  );
}

export function WarningIcon({ className }: IconProps) {
  return <ErrorIcon className={className} />;
}

export function InfoIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 3.4a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4ZM11.2 15H8.8v-6.4h2.4V15Z" />
    </svg>
  );
}

export function SuccessIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm4.3 6.1-5.2 6.2a1 1 0 0 1-1.5.05L5.2 10.9l1.5-1.4 1.6 1.7 4.5-5.4 1.5 1.3Z" />
    </svg>
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M15.3 6.1 11.4 10l3.9 3.9-1.4 1.4L10 11.4l-3.9 3.9-1.4-1.4L8.6 10 4.7 6.1l1.4-1.4L10 8.6l3.9-3.9 1.4 1.4Z" />
    </svg>
  );
}

export function MenuIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M2 4.5h16v2H2v-2Zm0 4.5h16v2H2V9Zm0 4.5h16v2H2v-2Z" />
    </svg>
  );
}
